var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenfitIncrease(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6499 8.6835L27.9999 13.3835C28.3166 14.0335 29.1666 14.6501 29.8832 14.7835L34.1333 15.4835C36.8499 15.9335 37.4833 17.9001 35.5333 19.8668L32.2166 23.1835C31.6666 23.7335 31.3499 24.8168 31.5333 25.6002L32.4832 29.7002C33.2332 32.9335 31.4999 34.2002 28.6499 32.5002L24.6666 30.1335C23.9499 29.7002 22.7499 29.7002 22.0333 30.1335L18.0499 32.5002C15.1999 34.1835 13.4666 32.9335 14.2166 29.7002L15.1666 25.6002C15.3499 24.8335 15.0333 23.7502 14.4833 23.1835L11.1666 19.8668C9.2166 17.9168 9.84993 15.9501 12.5666 15.4835L16.8166 14.7835C17.5332 14.6668 18.3833 14.0335 18.6999 13.3835L21.0499 8.6835C22.2999 6.1335 24.3666 6.1335 25.6499 8.6835Z",
    stroke: "url(#paint0_linear_33_573)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 8.3335H3.33333",
    stroke: "url(#paint1_linear_33_573)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 31.6665H3.33333",
    stroke: "url(#paint2_linear_33_573)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99999 20H3.33333",
    stroke: "url(#paint3_linear_33_573)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_573",
    x1: 23.3499,
    y1: 6.771,
    x2: 23.3499,
    y2: 33.2562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_573",
    x1: 8.33333,
    y1: 8.3335,
    x2: 8.33333,
    y2: 9.3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_573",
    x1: 5.83333,
    y1: 31.6665,
    x2: 5.83333,
    y2: 32.6665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33_573",
    x1: 4.16666,
    y1: 20,
    x2: 4.16666,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenfitIncrease);
export default __webpack_public_path__ + "static/media/benfit-increase.c1b9504f435044e3cbdb9b041e4d7b60.svg";
export { ForwardRef as ReactComponent };